/**
 * Analytics resource — org-scoped conversation + agent metrics (ARCHITECTURE §F).
 * Admin-gated server-side. `from`/`to` are ISO datetimes; omitted → last 30 days.
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';
import type { AnalyticsOverview, LeaderboardRow, QueueMetrics } from '../../types';

/** Optional [from, to) window for a metrics query. */
export interface AnalyticsWindow {
  from?: string;
  to?: string;
}

export class AnalyticsResource {
  constructor(private readonly http: HttpClient) {}

  overview(window: AnalyticsWindow = {}): Promise<AnalyticsOverview> {
    return this.http.get(endpoints.analytics.overview(), { query: { ...window } });
  }

  leaderboard(window: AnalyticsWindow = {}): Promise<LeaderboardRow[]> {
    return this.http.get(endpoints.analytics.leaderboard(), { query: { ...window } });
  }

  /** Real-time queue snapshot (current state, not windowed) — meant to be polled. */
  queue(): Promise<QueueMetrics> {
    return this.http.get(endpoints.analytics.queue());
  }
}
